import script from "./Airtime1View.vue?vue&type=script&setup=true&lang=js"
export * from "./Airtime1View.vue?vue&type=script&setup=true&lang=js"

import "./Airtime1View.vue?vue&type=style&index=0&id=54f0dbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f0dbca"]])

export default __exports__